<div *ngIf="form" [attr.id]="'form_'+_widgetId" [style.minHeight]="form._minFormHeight">
    <ng-container *ngIf="form && initStart">
        <!-- show layouts -->
        <strong-layout-builder [form]="form" [layout]="form.layout" (layoutLoadedEvent)="mainLayoutLoaded()">
        </strong-layout-builder>
    </ng-container>
</div>